import React from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import utilityConfig from 'app/configs/utilityConfigs'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

import Assets from 'app/configs/assetConfigs'

const ConfirmPasswordSuccess = (props) => {
  const { formatMessage } = useIntl()
  return (
    <PanelsIllustrationMSG>
      <div className="flex justify-center items-center h-full">
        <div className="w-full space-y-10">
          {/* Header */}
          <Typography className="text-24 font-500 text-blue-950 text-center">
            {formatMessage({ id: 'confirm.password.successPage.head' })}
          </Typography>
          <div className="flex w-full justify-center">
            <img src={Assets.confirmEmailSuccess} alt="Confrim email success" />
          </div>

          <Typography className="text-16 text-blue-950 text-center mx-5">
            {formatMessage({ id: 'confirm.password.successPage.body' })}
          </Typography>

          <Typography className="text-14 text-primary-300 text-center">
            {formatMessage(
              {
                id: 'suspended.footer',
              },
              {
                linkEmail: (
                  <a
                    href={`mailto:${utilityConfig.supportUrl}`}
                    className="text-blue-950 font-bold"
                  >
                    {utilityConfig.supportUrl}
                  </a>
                ),
              },
            )}
          </Typography>
        </div>
      </div>
    </PanelsIllustrationMSG>
  )
}

export default ConfirmPasswordSuccess
